import { render, staticRenderFns } from "./CorporativeAccountDetail.vue?vue&type=template&id=2eaf9ea6"
import script from "./CorporativeAccountDetail.vue?vue&type=script&lang=js"
export * from "./CorporativeAccountDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports